<template>
  <div>
    <v-dialog
      v-model="showMostruario"
      persistent
      :overlay="false"
      max-width="400px"
      transition="dialog-transition"
    >
    <v-col cols="12">
      <v-card>
        <v-card-title primary-title> Mostruário </v-card-title>
        <v-card-text>
          <v-row class="justify-center">
            <table>
              <tr v-for="rowIndex in rows" :key="rowIndex">
                <td v-for="colIndex in cols"
                :key="colIndex"
                :class="{ active: isActive(rowIndex, colIndex) }"
                @click="selectCell(rowIndex, colIndex)">
                  {{ items[(((rowIndex - 1) * cols + colIndex)-1)] }}
                </td>
              </tr>
            </table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="accent" @click="naoTem()">não tenho</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="confirme()">confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "we-transfer",
  computed: {
    showMostruario() {
      return this.$store.getters.showMostruario
    }
  },
  watch: {
    showMostruario(s) {
      if (s) {
        this.activeCell = null;
        this.itemSelected = null
      } 
    }
  },
  data() {
    return {
      items: this.setItems(),
      rows: 10,
      cols: 8,
      activeCell: null,
      itemSelected: null,
      disabled: true
    };
  },
  methods: {
    naoTem() {
      this.$store.dispatch("setMostruario", "Sem mostruário")
      this.$store.dispatch("setShowMostruario", false)
    },
    confirme() {
      this.$store.dispatch("setMostruario", this.itemSelected)
      this.$store.dispatch("setShowMostruario", false)
    },
    setItems() {
      const items = []
      const fim = 80;
      for (let i = 0; i < fim; i++) {
        const el = i + 1
        let item = el.toString()
        if (item.length === 1) {
          item = "00" + el
        }
        if (item.length === 2) {
          item = "0" + el
        }
        items.push(item)
      }
      return items
    },
    selectCell(row, col) {
      const text = ((row - 1) * this.cols + col);
      this.activeCell = { row, col, text };
      this.itemSelected = this.activeCell.text
      this.disabled = false
    },
    isActive(row, col) {
      return this.activeCell && this.activeCell.row === row && this.activeCell.col === col;
    },
  },
};
</script>
<style scoped>
  table {
    border-spacing: 8px 10px;
  }
  td {
    padding-left: 4px;
    padding-right: 4px;
    text-align: center;
    color: black;
    font-size: 10pt;
    background-color: #DDD;
  }
  td.active {
    color: white;
    background-color: teal;
  }
  td:hover {
    cursor: pointer;
  }
</style>